import React from 'react';
import { observer } from 'mobx-react';
import { FilterSelect } from './FilterSelect';
import { IFilterParams, IFilterSelectComposed, SelectType } from '../../../interfaces';
import { useOriginalUnitTypeSelect, useUiUnitTypeValue, useUiUnitTypeValues } from '../../../hooks';
import { tI } from '../../../translate';
import { Catcher } from '../../Catcher';

type IFilterOriginalUnitTypes = {
    filterParams: IFilterParams;
    onChange: (ids: IFilterSelectComposed) => void;
};
export const FilterOriginalUnitTypes: React.FC<IFilterOriginalUnitTypes> = observer(
    ({ filterParams, onChange }: IFilterOriginalUnitTypes) => {
        const unitTypes = filterParams?.unitTypes === SelectType.SINGLE ? useUiUnitTypeValue() : useUiUnitTypeValues();

        const onChangeUnitTypes = (ids: IFilterSelectComposed): void => {
            onChange(ids || filterParams.defaultUnitTypes);
        };

        return (
            <Catcher>
                <FilterSelect
                    idSpinners={['GET_ORIGINAL_UNIT_TYPE_SELECT']}
                    isBlockAllowClear={filterParams.isUnitTypesBlockClear}
                    mode={filterParams?.unitTypes}
                    onChange={onChangeUnitTypes}
                    title={tI('Unit Type Filter')}
                    useSelectHook={useOriginalUnitTypeSelect}
                    value={unitTypes}
                />
            </Catcher>
        );
    },
);
